import { svg } from "lit";
const icon = svg `<path d="M28.0308 35.3074L16.6924 23.969L28.0308 12.6113L29.6615 14.242L19.9538 23.969L29.6615 33.6766L28.0308 35.3074Z" fill="currentColor"/>`;
export default icon;
